export default "__VITE_ASSET__DoVXGZDs__"